import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import axios from "axios";
import VueAxios from "vue-axios";

import VueLodash from "vue-lodash";
import lodash from "lodash";

import VueCookies from "vue-cookies";

Vue.config.productionTip = false;
axios.defaults.withCredentials = true;

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(VueLodash, { lodash: lodash });
Vue.use(VueCookies);

new Vue({
  router,
  store: store,
  render: (h) => h(App),
}).$mount("#app");
